import { type ZodType, z } from 'zod';
import {
  MarketParticipantStatus,
  type OrganisationFilterResponse,
} from '#pie/internal/api/pie-bff';
import {
  type AvailableOrganisationFilters,
  MarketParticipantType,
} from '#pie/internal/api/pie-bff/generated/model';
import { getValues } from '#pie/utils/ZodUtils';
import { createFiltersAtom } from './createFiltersAtom';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultMarketPartiesRegistrySortingAtom: DefaultSorting<OrganisationFilterResponse> =
  {
    desc: false,
    id: 'statutoryName',
  };

export const marketPartiesRegistrySortingAtom = createSortingAtom({
  defaultSorting: defaultMarketPartiesRegistrySortingAtom,
});

export const allowedMarketRoles = [
  MarketParticipantType.EZ,
  MarketParticipantType.DDM,
  MarketParticipantType.CDS,
  MarketParticipantType.DDQ,
  MarketParticipantType.EDSN,
] as const;

export const defaultMarketPartyRegistryFilters: AvailableOrganisationFilters = {
  marketRoles: [],
  statuses: [MarketParticipantStatus.Active],
};

export const marketPartiesFiltersSchema: ZodType<
  AvailableOrganisationFilters,
  unknown
> = z.object({
  marketRoles: z
    .array(z.enum(getValues(MarketParticipantType)))
    .optional()
    .default([])
    .catch([]),
  statuses: z
    .array(z.enum(getValues(MarketParticipantStatus)))
    .optional()
    .default([MarketParticipantStatus.Active])
    .catch([]),
});

export const marketPartyRegistryFiltersAtom =
  createFiltersAtom<AvailableOrganisationFilters>({
    defaultFilters: defaultMarketPartyRegistryFilters,
    filtersSchema: marketPartiesFiltersSchema,
  });
